module.exports = "/_next/static/images/6eb80b9a57ebf9248a3407bf0e16b370-savingsbanner-xs-1x.jpg.webp";